/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import { css, FlattenSimpleInterpolation } from 'styled-components';

import { UiBreakpoint } from '../../utils/constants';

const RestrictionCardStyles = (): FlattenSimpleInterpolation => css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 24px;
  align-items: center;
  text-align: left;

  .device-image {
    width: 64px;
    display: block;
    margin: 0 auto;
  }

  .device-name {
    color: var(--color-grey900);
    font-family: var(--font-bold);
    font-size: 14px;
    margin-bottom: 8px;
  }

  .os-browser-versions {
    margin-top: 0;
    padding-left: 16px;
    max-width: 200px;
    li {
      font-size: 13px;
      line-height: 20px;
      margin-bottom: 4px;
    }
  }

  @media (max-width: ${UiBreakpoint}px) {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    text-align: center;

    .os-browser-versions {
      list-style-type: none;
    }
  }
`;

export default RestrictionCardStyles;
